import styled from 'styled-components';
import * as Cards from 'eCoach/_styles/Cards.style';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';
import * as Text from 'theme/components/Text.style';

interface SectionProps {
  eCoach?: boolean;
}

export const Section = styled('div')<SectionProps>`
  align-items: ${(props) => (props.eCoach ? 'flex-start' : 'flex-end')};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;

  @media (max-width: ${breakpoints.tablet}) {
    padding: 20px;
  }
`;

export const Card = styled(Cards.Card)`
  background: linear-gradient(279deg, #36475a 1.35%, #1a2634 102.58%);
  background-position: center;
  background-size: cover;
  gap: 10px;
  max-width: 530px;
  padding: 20px;
`;

export const Label = styled(Text.P2Semibold)``;

export const Icon = styled('div')`
  align-items: center;
  border-radius: 50px;
  display: flex;
  height: 30px;
  justify-content: center;
  padding: 5px;
  width: 30px;

  svg {
    height: 35px;
    width: 35px;
  }
`;

export const TextSection = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Description = styled(Text.P2Semibold)`
  color: ${colours.neutral[900]};
`;
